(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sff-creator-highlights"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('sff-creator-highlights')) return;
    let activeShelf;
    let apiPromise;
    const youtube = () => {
      if (window.YT && window.YT.Player) return Promise.resolve(window.YT);
      if (apiPromise) return apiPromise;
      apiPromise = new Promise((resolve, reject) => {
        const previous = window.onYouTubeIframeAPIReady;
        const timer = window.setTimeout(() => { apiPromise = null; reject(new Error('YouTube API timeout')); }, 15000);
        window.onYouTubeIframeAPIReady = () => {
          window.clearTimeout(timer);
          try { if (typeof previous === 'function') previous(); } finally { resolve(window.YT); }
        };
        if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
          const script = document.createElement('script');
          script.src = 'https://www.youtube.com/iframe_api';
          script.async = true;
          script.onerror = () => { window.clearTimeout(timer); apiPromise = null; script.remove(); reject(new Error('YouTube API unavailable')); };
          document.head.append(script);
        }
      });
      return apiPromise;
    };
    class CreatorHighlights extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.rail = this.querySelector('[data-rail]');
        this.status = this.querySelector('[data-status]');
        this.querySelectorAll('[data-play]').forEach(button => { button.hidden = false; });
        this.addEventListener('click', event => {
          const play = event.target.closest('[data-play], [data-restart]');
          if (play) this.play(play.closest('[data-highlight]'));
          const arrow = event.target.closest('[data-direction]');
          if (arrow) this.move(Number(arrow.dataset.direction));
        }, options);
        this.rail.addEventListener('keydown', event => {
          if (event.target !== this.rail || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') this.rail.scrollTo({ left: event.key === 'Home' ? 0 : this.rail.scrollWidth, behavior: this.motion() });
          else this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        this.rail.addEventListener('scroll', () => this.updateArrows(), { ...options, passive: true });
        this.resize = new ResizeObserver(() => this.updateArrows());
        this.resize.observe(this.rail);
        this.updateArrows();
      }
      disconnectedCallback() {
        this.stop();
        this.abort?.abort();
        this.abort = null;
        this.resize?.disconnect();
      }
      motion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
      move(direction) {
        const card = this.rail.querySelector('[data-highlight]');
        const gap = parseFloat(window.getComputedStyle(this.rail).columnGap) || 0;
        if (card) this.rail.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: this.motion() });
      }
      updateArrows() {
        const max = this.rail.scrollWidth - this.rail.clientWidth;
        this.querySelector('[data-arrows]').hidden = max < 2;
        this.querySelector('[data-direction="-1"]').disabled = this.rail.scrollLeft <= 2;
        this.querySelector('[data-direction="1"]').disabled = this.rail.scrollLeft >= max - 2;
      }
      stop() {
        this.token = (this.token || 0) + 1;
        window.clearInterval(this.monitor);
        window.clearTimeout(this.readyTimer);
        this.monitor = null;
        if (this.player) { this.player.destroy(); this.player = null; }
        if (this.card) {
          this.card.querySelector('[data-player]').replaceChildren();
          this.card.removeAttribute('data-active');
          const button = this.card.querySelector('[data-play]');
          button.hidden = false;
          button.disabled = false;
          button.setAttribute('aria-label', button.dataset.replayLabel);
          button.querySelector('[data-play-text]').textContent = this.dataset.replay;
          this.card.querySelector('[data-restart]').hidden = true;
        }
        this.card = null;
        if (this.status) this.status.textContent = '';
        if (activeShelf === this) activeShelf = null;
      }
      finish() {
        const focused = this.card?.contains(document.activeElement);
        const button = this.card?.querySelector('[data-play]');
        this.stop();
        this.status.textContent = this.dataset.ended;
        if (focused) button?.focus({ preventScroll: true });
      }
      async play(card) {
        const videoId = card?.dataset.video;
        const startSeconds = Number(card?.dataset.start);
        const endSeconds = Number(card?.dataset.end);
        if (!/^[A-Za-z0-9_-]{11}$/.test(videoId || '') || !Number.isInteger(startSeconds) || !Number.isInteger(endSeconds) || startSeconds < 0 || endSeconds <= startSeconds) return;
        if (activeShelf) activeShelf.stop();
        this.stop();
        activeShelf = this;
        this.card = card;
        const token = this.token;
        const current = () => this.isConnected && this.token === token && this.card === card;
        const button = card.querySelector('[data-play]');
        button.disabled = true;
        this.status.textContent = this.dataset.loading;
        const clip = { videoId, startSeconds, endSeconds };
        try {
          const YT = await youtube();
          if (!current()) return;
          const iframe = document.createElement('iframe');
          const url = new URL('https://www.youtube-nocookie.com/embed/' + videoId);
          const params = { enablejsapi: 1, autoplay: 0, playsinline: 1, rel: 0, start: startSeconds, end: endSeconds, origin: window.location.origin };
          Object.entries(params).forEach(([key, value]) => url.searchParams.set(key, value));
          iframe.src = url.href;
          iframe.title = card.querySelector('h3').textContent;
          iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
          iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('loading', 'lazy');
          card.querySelector('[data-player]').append(iframe);
          card.setAttribute('data-active', '');
          this.readyTimer = window.setTimeout(() => {
            if (current()) { this.stop(); this.status.textContent = this.dataset.error; }
          }, 20000);
          this.player = new YT.Player(iframe, { events: {
            onReady: event => {
              if (!current()) return;
              window.clearTimeout(this.readyTimer);
              button.hidden = true;
              button.disabled = false;
              card.querySelector('[data-restart]').hidden = false;
              this.status.textContent = '';
              event.target.loadVideoById(clip);
              iframe.focus({ preventScroll: true });
            },
            onStateChange: event => {
              if (!current()) return;
              window.clearInterval(this.monitor);
              this.monitor = null;
              if (event.data === 0) { this.finish(); return; }
              if (event.data === 1) {
                this.status.textContent = '';
                const enforce = () => {
                  if (!current()) return;
                  const time = event.target.getCurrentTime();
                  if (time >= endSeconds) this.finish();
                  else if (time < startSeconds - 1) event.target.loadVideoById(clip);
                };
                enforce();
                if (current()) this.monitor = window.setInterval(enforce, 250);
              }
            },
            onAutoplayBlocked: () => { if (current()) this.status.textContent = this.dataset.blocked; },
            onError: () => { if (current()) { this.stop(); this.status.textContent = this.dataset.error; } }
          }});
        } catch (error) {
          if (current()) { this.stop(); this.status.textContent = this.dataset.error; }
        }
      }
    }
    customElements.define('sff-creator-highlights', CreatorHighlights);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sff-goat-clan-banner"] && !Shopify.designMode) return;
  try {
    function initializeGoatClanBanners(root) {
    root.querySelectorAll('[data-goat-clan-promo]').forEach((banner) => {
      if (banner.dataset.ready) return;
      banner.dataset.ready = 'true';
      const count = banner.querySelector('[data-clan-count]');
      const label = banner.querySelector('[data-clan-member-label]');
      const music = banner.querySelector('[data-clan-music-label]');
      let pending = false;
      async function refreshCount() {
        if (pending || document.hidden || !banner.isConnected) return;
        pending = true;
        try {
          const response = await fetch('https://goat-clan.steinmetzfamilyfarms.chatgpt.site/api/clan-stats', {credentials:'omit',signal:AbortSignal.timeout(6000)});
          if (!response.ok) throw new Error('Unavailable');
          const stats = await response.json();
          if (!Number.isSafeInteger(stats.memberCount) || stats.memberCount < 1) throw new Error('Invalid count');
          count.textContent = stats.memberCount.toLocaleString();
          count.hidden = false;
          label.textContent = stats.memberCount === 1 ? label.dataset.one : label.dataset.many;
          if (Number.isSafeInteger(stats.musicTrackCount) && stats.musicTrackCount > 0) {
            music.textContent = music.dataset.template.replace('[count]', stats.musicTrackCount.toLocaleString());
          }
        } catch {
          count.hidden = true;
          label.textContent = label.dataset.fallback;
        } finally {
          pending = false;
        }
      }
      refreshCount();
      window.addEventListener('pageshow', refreshCount);
      document.addEventListener('visibilitychange', refreshCount);
      const timer = window.setInterval(() => {
        if (!banner.isConnected) return window.clearInterval(timer);
        refreshCount();
      }, 60000);
    });
  }
  initializeGoatClanBanners(document);
  document.addEventListener('shopify:section:load', (event) => initializeGoatClanBanners(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sff-what-if-launch"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.sffWhatIfLaunch) return;
  window.sffWhatIfLaunch = true;
  let roots = [], config = {}, strings = {}, stateUrl = '', busy = false;
  let availableCount = 0, failures = 0;
  const readJson = (node) => { try { return JSON.parse(node?.textContent || '{}'); } catch { return {}; } };
  const validVideo = (id) => /^[A-Za-z0-9_-]{11}$/.test(id || '');
  function discover() {
    roots = [...document.querySelectorAll('[data-wia-launch]')];
    if (!roots.length) return;
    config = {...config, ...readJson(roots[0].querySelector('[data-wia-config]'))};
    strings = readJson(roots[0].querySelector('[data-wia-strings]'));
    stateUrl = roots[0].dataset.wiaStateUrl;
    render();
  }
  function revealProducts() {
    if (config.teaser || config.status !== 'live' || Date.now() < Date.parse(config.launch_at)) return;
    (config.products || []).forEach((item) => {
      document.querySelectorAll('[data-wia-reveal-image]').forEach((img) => {
        if (img.dataset.wiaRevealImage !== item.model || img.dataset.wiaRevealed) return;
        const source = new URL(item.image_url, location.origin);
        if (source.protocol !== 'https:') return;
        source.searchParams.set('width', img.closest('.wia-launch__photo') ? '480' : '640');
        img.removeAttribute('srcset');
        img.src = source.href;
        img.alt = item.alt || item.model;
        img.dataset.wiaRevealed = 'true';
      });
      document.querySelectorAll('[data-wia-model]').forEach((card) => {
        if (card.dataset.wiaModel !== item.model) return;
        card.dataset.wiaProduct = item.handle;
        const title = card.querySelector('[data-wia-product-title]');
        const color = card.querySelector('[data-wia-color]');
        if (title) title.textContent = item.title;
        if (color) { color.textContent = '· ' + item.color; color.hidden = false; }
      });
    });
    document.querySelectorAll('[data-wia-options-note]').forEach((node) => { node.textContent = strings.options_note; });
    document.querySelectorAll('[data-wia-products-heading]').forEach((node) => { node.textContent = strings.products_title; });
    document.querySelectorAll('[data-wia-products-copy]').forEach((node) => { node.textContent = strings.products_copy; });
  }
  function render() {
    const now = Date.now(), start = Date.parse(config.launch_at), end = Date.parse(config.banner_until);
    if (!Number.isFinite(start)) return;
    revealProducts();
    const started = now >= start;
    const live = started && (config.status === 'live' || availableCount === (config.products || []).length && availableCount > 0);
    const phase = live ? 'live' : started ? 'time' : 'before';
    const seconds = Math.max(0, Math.ceil((start - now) / 1000));
    const units = {days: Math.floor(seconds / 86400), hours: Math.floor(seconds % 86400 / 3600), minutes: Math.floor(seconds % 3600 / 60), seconds: seconds % 60};
    roots.forEach((root) => {
      if (root.dataset.wiaMode === 'banner') root.hidden = Number.isFinite(end) && now >= end;
      if (root.dataset.wiaPhase !== phase) {
        root.dataset.wiaPhase = phase;
        const heading = root.querySelector('[data-wia-heading]'), status = root.querySelector('[data-wia-status]');
        if (heading) heading.textContent = strings['title_' + phase] || '';
        if (status) status.textContent = strings['status_' + phase] || '';
      }
      root.querySelectorAll('[data-wia-unit]').forEach((node) => { node.textContent = String(units[node.dataset.wiaUnit] || 0).padStart(2, '0'); });
      const clock = root.querySelector('[data-wia-clock]');
      if (clock) clock.hidden = started;
    });
    if (!started) document.querySelectorAll('[data-wia-product-link]').forEach((link) => { link.removeAttribute('href'); link.setAttribute('aria-disabled','true'); link.tabIndex = -1; });
    if (live) document.querySelectorAll('.sff-creator__category').forEach((card) => {
      const link = card.querySelector('a[href*="/collections/what-if-acres-1"]');
      if (!link) return;
      card.classList.remove('sff-creator__category--soon');
      const status = card.querySelector('.sff-creator__status');
      if (status) { status.textContent = strings.available; status.classList.remove('sff-creator__status--muted'); }
      link.textContent = strings.shop_apparel;
    });
    if (validVideo(config.live_video_id)) document.querySelectorAll('[data-wia-youtube]').forEach((link) => { link.href = 'https://www.youtube.com/watch?v=' + config.live_video_id; });
    const frame = document.querySelector('[data-wia-live-frame]');
    if (frame && validVideo(config.live_video_id) && now >= start - 900000 && (!Number.isFinite(end) || now < end)) {
      if (frame.dataset.wiaVideo !== config.live_video_id) {
        frame.dataset.wiaVideo = config.live_video_id;
        frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(config.live_video_id) + '?rel=0&playsinline=1&controls=1';
        frame.title = strings.live_heading;
        const section = frame.closest('.sff-creator__section');
        if (section) {
          section.classList.add('wia-live-active');
          const heading = section.querySelector('h2'), copy = section.querySelector('.sff-creator__subcopy'), note = section.querySelector('.sff-creator__video-note');
          if (heading) heading.textContent = strings.live_heading;
          if (copy) copy.textContent = strings.live_copy;
          if (note) note.textContent = strings.live_note;
        }
      }
    }
  }
  async function checkProducts() {
    if (config.teaser || config.status !== 'live' || Date.now() < Date.parse(config.launch_at)) return;
    const cards = [...document.querySelectorAll('[data-wia-product]')];
    if (!cards.length) return;
    let found = 0;
    await Promise.allSettled(cards.map(async (card) => {
      try {
        const response = await fetch('/products/' + encodeURIComponent(card.dataset.wiaProduct) + '.js', {cache:'no-store',headers:{Accept:'application/json'}});
        if (!response.ok) return;
        const product = await response.json();
        if (!product.id || !Number.isFinite(product.price) || product.price <= 0) return;
        found++;
        const link = card.querySelector('[data-wia-product-link]'), price = card.querySelector('[data-wia-price]');
        if (link) { link.href = '/products/' + encodeURIComponent(card.dataset.wiaProduct); link.removeAttribute('aria-disabled'); link.removeAttribute('tabindex'); link.textContent = product.available ? strings.shop : strings.view; }
        if (price) price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:product.currency || window.Shopify?.currency?.active || 'USD'}).format(product.price / 100);
      } catch {}
    }));
    availableCount = found;
  }
  async function refresh() {
    if (busy || document.hidden || !roots.length) return;
    busy = true;
    try {
      if (stateUrl && Date.now() < Date.parse(config.banner_until)) {
        try {
          const response = await fetch(stateUrl + '&_wia=' + Math.floor(Date.now()/60000),{cache:'no-store',headers:{Accept:'application/json'}});
          if (!response.ok) throw new Error('Launch state unavailable');
          const next = await response.json();
          if (next && next.launch_at) { config = {...config,...next,teaser:Boolean(next.teaser)}; revealProducts(); failures = 0; } else failures++;
        } catch { failures++; }
      }
      await checkProducts();
      render();
    } catch { failures++; } finally { busy = false; }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => { discover(); refresh(); },{once:true}); else { discover(); refresh(); }
  setInterval(render,1000);
  setInterval(refresh,60000);
  document.addEventListener('visibilitychange',() => { if (!document.hidden) { failures = 0; refresh(); } });
  document.addEventListener('shopify:section:load',() => { discover(); refresh(); });
})();
  } catch(e) { console.error(e); }
})();

})();
